import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { Observable } from "rxjs";

import { AuthService } from "../../../../../core/service/auth.service";
import { DevoluciónDineroResponse } from "../interfaces/devoluciones.interface";

@Injectable({
  providedIn: 'root'
})

export class DevolucionesService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private authService: AuthService) { }


  loadDevoluciones(): Observable<DevoluciónDineroResponse> {

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.authService.getToken()}`
    })
    return this.http.get<DevoluciónDineroResponse>(`${this.apiUrl}/refunds/orders`, { headers });
  }
}
